import { useId, useState } from 'react';
import { Icon } from './Icon';

/**
 * A quiet explanation attached to a label. The text stays in the DOM and is
 * wired through aria-describedby, so it reaches assistive tech whether or not
 * the bubble is visible; the click toggle exists for touch, where there is no
 * hover.
 */
export function Infotip({
  text,
  label,
  align = 'start',
}: {
  text: string;
  /** What the tip explains, used to name the trigger for screen readers. */
  label: string;
  align?: 'start' | 'end';
}) {
  const id = useId();
  const [pinned, setPinned] = useState(false);
  return (
    <span className={`infotip is-${align}${pinned ? ' is-pinned' : ''}`}>
      <button
        type="button"
        className="infotip-trigger"
        aria-label={`About ${label}`}
        aria-describedby={id}
        onClick={() => setPinned(p => !p)}
        onBlur={() => setPinned(false)}
      >
        <Icon name="info" size={14} stroke={1.9} />
      </button>
      <span role="tooltip" id={id} className="infotip-bubble">
        {text}
      </span>
    </span>
  );
}
